export enum ERoles {
  Spec = 'SPECIALIST',
  Client = 'CLIENT',
  Admin = 'ADMIN',
  Unauthorized = 'UNAUTHORIZED',
}
